module.exports = __webpack_public_path__ + "static/media/partners.360cb169.png";